import React, { useState, useEffect } from 'react';
import SearchTalentsFilter from './SearchTalentsFilter';
import { useParams } from 'react-router-dom';
import SearchTalentCard from './SearchTalentCard/SearchTalentCard';
import './searchTalentsView.css'

const SearchTalentsView = () => {
    const { id } = useParams();
    const [talents, setTalents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);

    // Test search on component mount to see if there are any employees
    useEffect(() => {
        const testSearch = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employees/search`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const data = await response.json();
        
                } 
            } catch (error) {
                console.log('🧪 Test search error:', error);
            }
        };

        testSearch();
    }, []);

    const handleSearchFilter = async (filters) => {
        try {
            setIsLoading(true);
            setError(null);
            const queryParams = new URLSearchParams(filters).toString();
            
         
            const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employees/search?${queryParams}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

        
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                console.error('🔍 Search error response:', errorData);
                throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
            }

            const data = await response.json(); 
           
            // Ensure we always set an array, handle both direct array and wrapped responses
            const talentsArray = Array.isArray(data) ? data : (data.employees || data.data || []);
          
            setTalents(talentsArray);
            setHasSearched(true);

        } catch (error) {
            console.error('Error fetching filtered data:', error);
            setError(error.message);
            setTalents([]); // Ensure talents remains an empty array on error
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="search-talents-view__container">
            <h1>Busca nuevos talentos</h1>
            
            {/* Plan requirement message - styled nicely */}
            <div className="search-talents-view__plan-notice">
                <div className="plan-notice__content">
                    <div className="plan-notice__icon">🚀</div>
                    <div className="plan-notice__text">
                        <h3>Funcionalidad Premium</h3>
                        <p>El buscador de talentos está disponible exclusivamente para usuarios con plan PLUS o PREMIUM.</p>
                        <button className="plan-notice__upgrade-btn">Actualizar Plan</button>
                    </div>
                </div>
            </div>
            
            <SearchTalentsFilter handleSearchFilter={handleSearchFilter} />
            
            {isLoading && <div className="search-talents-view__loading">Cargando talentos...</div>}
            {error && <div className="search-talents-view__error">Error: {error}</div>}
            
            <div className="search-talents-view__results">
                {Array.isArray(talents) && talents.length > 0 ? (
                    <>
                        <div className="search-talents-view__results-count">
                            Se encontraron {talents.length} talento(s)
                        </div>
                        <div className="search-talents-view__cards-wrapper">
                            {talents.map((employee) => (
                                <SearchTalentCard
                                    key={employee.id}
                                    data={employee}
                                    id={employee.id}
                                    employeeId={employee.id} 
                                    type="dashboard"
                                />
                            ))}
                        </div>
                    </>
                ) : (
                    !isLoading && !error && (
                        <div className="search-talents-view__empty-state">
                            <div className="empty-state__icon" aria-hidden="true">
                                {hasSearched ? '🔍' : '👋'}
                            </div>
                            <h3 className="empty-state__title">
                                {hasSearched
                                    ? 'No encontramos talentos'
                                    : 'Comienza tu búsqueda'}
                            </h3>
                            <p className="empty-state__message">
                                {hasSearched
                                    ? 'No hay perfiles que coincidan con los filtros que elegiste. Prueba ampliando criterios o cambiando alguna opción.'
                                    : 'Usa los filtros de arriba para buscar talentos que se ajusten a lo que necesitas.'}
                            </p>
                            {hasSearched && (
                                <p className="empty-state__tip">
                                    Tip: menos filtros suelen dar más resultados.
                                </p>
                            )}
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default SearchTalentsView;
